import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';

// Remote page will reset state if reset is true; Otherwise, keep the current
// state.
const GoHomePanelCommand = Command.extend({
  detail: {
    reset: Boolean
  }
}).defaultTo(
  generateDefault({
    action: commandList.GO_HOME_PANEL,
  })
);

const GoSearchPanelCommand = Command.extend({
  detail: {
    keywords: String
  },
}).defaultTo(
  generateDefault({
    action: commandList.GO_SEARCH_PANEL,
  })
);

const OpenBrowserWindowCommand = Command.extend({
  detail: {
    keywords: String
  },
}).defaultTo(
  generateDefault({
    action: commandList.OPEN_BROWSER_WINDOW,
  })
);

const PickOptionMenuCommand = Command.extend({
  detail: {
    itemName: String
  },
}).defaultTo(
  generateDefault({
    action: commandList.PICK_OPTION_MENU,
  })
);

const RemoteUIReadyCommand = Command.extend({
  detail: {
    timestamp: [Number],
    isInlineActivity: Boolean,
  },
}).defaultTo(
  generateDefault({
    action: commandList.REMOTE_UI_IS_READY,
  })
);
const PostTopsitesCommand = Command.extend({
  detail: {
    topsites: [Object],
  }
}).defaultTo(
  generateDefault({
    action: commandList.POST_TOP_SITES
  })
);

export {
  GoHomePanelCommand,
  GoSearchPanelCommand,
  OpenBrowserWindowCommand,
  PickOptionMenuCommand,
  RemoteUIReadyCommand,
  PostTopsitesCommand,
};
